import {Action} from "@ngrx/store";

export const LOAD_TROUBLE_SHOOT_DATA: string = '[website] Load Trouble Shoot Data';
export const LOAD_TROUBLE_SHOOT_DATA_SUCCESS: string = '[website] Load Trouble Shoot Data Success';
export const LOAD_TROUBLE_SHOOT_DATA_FAIL: string = '[website] Load Trouble Shoot Data Fail';

export class LoadTroubleShootData implements Action {

  readonly type: string = LOAD_TROUBLE_SHOOT_DATA;
  constructor(public payload:  {
    websiteId: number,
    websiteUrl: string
  }) {}

}

export class LoadTroubleShootDataSuccess implements Action {

  readonly type: string = LOAD_TROUBLE_SHOOT_DATA_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    data: any
  }) {}

}

export class LoadTroubleShootDataFail implements Action {

  readonly type: string = LOAD_TROUBLE_SHOOT_DATA_FAIL;
  constructor(public payload: {
    websiteId: number,
    data: any
  }) {}

}


export type TroubleShootDataAction = LoadTroubleShootData | LoadTroubleShootDataSuccess | LoadTroubleShootDataFail;
